import { ArticlePerformanceRow } from '../../../../services/performanceMetricsService';

export const formatNumber = (n: number | null | undefined): string => {
  if (n == null) return '—';
  if (n >= 10000) return `${(n / 1000).toFixed(0)}k`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
  return String(n);
};

export const formatPercent = (n: number | null | undefined): string => {
  if (n == null) return '—';
  return `${(n * 100).toFixed(1)}%`;
};

export const formatPosition = (n: number | null | undefined): string => {
  if (n == null) return '—';
  return n.toFixed(1);
};

export const formatDate = (iso: string | null | undefined): string => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  } catch {
    return '—';
  }
};

export const decodeHtmlEntities = (str: string): string => {
  if (!str) return str;
  return str
    .replace(/&#038;/g, '&')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#8217;/g, '\u2019')
    .replace(/&#8216;/g, '\u2018')
    .replace(/&#8220;/g, '\u201c')
    .replace(/&#8221;/g, '\u201d')
    .replace(/&#8211;/g, '\u2013')
    .replace(/&#8212;/g, '\u2014')
    .replace(/&hellip;/g, '\u2026')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>');
};

export const positionTone = (pos: number | null | undefined): string => {
  if (pos == null) return 'text-gray-300';
  if (pos <= 3) return 'text-green-600';
  if (pos <= 10) return 'text-gray-900';
  if (pos <= 20) return 'text-amber-600';
  return 'text-gray-400';
};

export const positionDelta = (latest: number | null | undefined, avg: number | null | undefined) => {
  if (latest == null || avg == null) return null;
  const diff = avg - latest;
  if (Math.abs(diff) < 0.3) return { tone: 'text-gray-400', symbol: '\u00b7' };
  if (diff > 0) return { tone: 'text-green-600', symbol: '\u25b2' };
  return { tone: 'text-red-500', symbol: '\u25bc' };
};

export const formatAvgPerDay = (n: number | null | undefined): string => {
  if (n == null) return '—';
  if (n < 10) return n.toFixed(1);
  return String(Math.round(n));
};
